import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=4c85d496&scoped=true&"
import script from "./LayoutPage.vue?vue&type=script&lang=js&"
export * from "./LayoutPage.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=4c85d496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85d496",
  null
  
)

export default component.exports